import { createClient } from '@supabase/supabase-js';
const url = process.env.REACT_APP_SUPABASE_URL || 'https://rmoxuodrbhesecbxiwtz.supabase.co';
const key = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJtb3h1b2RyYmhlc2VjYnhpd3R6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk5Njg4NzgsImV4cCI6MjA4NTU0NDg3OH0.YGw29aX2_7s3KWIs0vI8_tSAJAos7Sxnp0tfS7bLOjc';
export const supabase = createClient(url, key);
